<template>
    <div class="py-4">
        <h3 class="pb-8 text-2xl">
            <span class="font-bold">{{ manufacturer.name }}</span>
            OEM tyre brands
        </h3>

        <Transition name="fade" mode="out-in">
            <div v-if="!loading" class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                <template v-if="brands.length > 0">
                    <BrandImage v-for="brand of brands" :brand="brand"></BrandImage>
                </template>

                <p class="col-span-full py-4" v-else>
                    We don't have enough information about OEM tyre brands suitable for {{ manufacturer.name }}
                    vehicles.
                </p>
            </div>

            <div v-else class="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
                <BrandImageLoader v-for="i in 6"></BrandImageLoader>
            </div>
        </Transition>
    </div>
</template>

<script>
import BrandImage from "@/Components/Brands/BrandImage";
import BrandImageLoader from "@/Components/Loaders/BrandImageLoader";

export default {
    components: {BrandImageLoader, BrandImage},
    props: {
        manufacturer: Object,
        brands: Array,
        loading: Boolean
    },
};
</script>

<style scoped>

</style>
